<template>
  <div v-if="is_h5 == false" class="search-wrap ibp-major-content-shell">
    <!-- 布局与样式对齐 courseMajorDisplay「查找专业」toolbar-card -->
    <div class="toolbar-card home-course-search-card">
      <div class="toolbar-card__intro">
        <span class="toolbar-card__label">课程资源检索</span>
        <el-button text type="primary" size="small" @click="resetClassFilters">重置筛选</el-button>
      </div>

      <div v-if="allClassItems.length" class="search-filter-row">
        <template v-for="(item, idx) in allClassItems" :key="dictFieldKey(item) || 'dim-' + idx">
          <div v-if="dictFieldKey(item)" class="dim-card">
            <button
              type="button"
              class="dim-l1-chip"
              :class="{ 'dim-l1-chip--on': isFirstLevelQueryActive(item) }"
              :title="'按「' + (item.label || item.dict_name) + '」筛选（该分类字段有值）'"
              @click="toggleFirstLevelQuery(item)"
            >
              {{ item.label || item.dict_name }}
            </button>
            <div class="dim-select-wrap">
              <el-select
                v-model="classActiveDict[dictFieldKey(item)]"
                class="dim-select-el"
                filterable
                clearable
                placeholder="子类"
                @change="onClassDictChange"
              >
                <el-option label="全部" value="全部" />
                <el-option
                  v-for="(cItem, cIdx) in (item.children || [])"
                  :key="childSelectValue(cItem) || 'c-' + cIdx"
                  :label="cItem.label || cItem.dict_name"
                  :value="childSelectValue(cItem)"
                  :disabled="!childSelectValue(cItem)"
                />
              </el-select>
            </div>
          </div>
        </template>
      </div>

      <el-input
        v-model="searchValue"
        class="search-input"
        size="large"
        clearable
        placeholder="输入课程名称、关键词，回车搜索"
        @keyup.enter="goToSearchResult"
        @clear="goToSearchResult"
      >
        <template #prefix>
          <el-icon class="search-ico"><Search /></el-icon>
        </template>
        <template #append>
          <el-button type="primary" @click="goToSearchResult">搜索</el-button>
        </template>
      </el-input>
    </div>
  </div>
  <div v-else class="van-nav-bar--fixed" :style="{top:is_top?'46px':0}" style="z-index: var(--van-nav-bar-z-index);">
    
    <van-tabs>
      <!--
      <van-tab v-for="item in searchAreaType" :key="item.value" :title="item.label" :name="item.value">
      </van-tab>
      -->
      <van-tab key="课程中心" title="课程中心" name="课程中心">
      </van-tab>
      <template #nav-left>
        <van-icon name="arrow-left" class="fixedly-btn-left" @click="gotoRoute('Index')"/>
        <i class="placeholder"></i>
      </template>
      <template #nav-right>
        <i class="placeholder"></i>
        <van-icon name="wap-nav" class="fixedly-btn-right" @click="showTop=true"></van-icon>
      </template>
    </van-tabs>
    
    <!-- 顶部弹出 -->
    <van-popup v-model:show="showTop" closeable position="top" class="h5-filter-popup">
      <div v-if="allClassItems.length" class="h5-l1-panel">
        <div class="h5-l1-panel-title">大类快捷筛选</div>
        <div class="h5-l1-tags">
          <button
            v-for="(item, idx) in allClassItems"
            v-show="dictFieldKey(item)"
            :key="dictFieldKey(item) || 'h5-' + idx"
            type="button"
            class="h5-l1-pill"
            :class="{ 'h5-l1-pill--on': isFirstLevelQueryActive(item) }"
            @click="toggleFirstLevelQuery(item)"
          >{{ item.label || item.dict_name }}</button>
        </div>
      </div>
      <van-form class="h5-filter-form">
        <van-field v-for='(item, idx) in allClassItems'
          :key="dictFieldKey(item) || idx" 
          :label="item.label"
          v-model="classActiveNameDict[dictFieldKey(item)]"
          is-link
          readonly
          name="picker"
          :placeholder="'点击选择' + item.label"
          @click="showPickers[dictFieldKey(item)] = true"
        />
        <van-popup v-model:show="showPickers[dictFieldKey(item)]" position="bottom"  v-for='(item, idx) in allClassItems' 
          :key="dictFieldKey(item) || idx" 
          :label="item.label">
          <van-picker
            :columns="toColumns(dictFieldKey(item), item.children)"
            @confirm="onConfirm"
            @cancel="showPickers[dictFieldKey(item)] = false"
          />
        </van-popup>
        <van-field v-model="searchValue" center label="检索内容" placeholder="请输入检索内容">
          <template #button>
            <!--<van-button size="small" type="primary" @click="goToSearchResult">搜索一下</van-button> -->
          </template>
        </van-field>
        
      </van-form>
      <div class="h5-sheet-footer">
        <van-button class="h5-footer-btn" round plain hairline type="default" @click="clearSearchParam">重置</van-button>
        <van-button class="h5-footer-btn h5-footer-btn--primary" round type="primary" @click="goToSearchResult(true)">应用筛选</van-button>
      </div>
    </van-popup>
  </div>

</template>

<script>
import {showNotify} from 'vant';
import { ref } from 'vue';
import { Search } from '@element-plus/icons-vue';
export default {
  name: "zySearch",
  components: {
    Search,
  },
  props: {
    is_top: {
      type: Boolean,
      default: () => false,
    },
    is_h5: {
      type: Boolean,
      default: () => false,
    }
  },
  setup() {
    const result = ref('');
    const columns = [
      { text: '杭州', value: 'Hangzhou' }
    ];
    const apiUrls = {
      'getClassItems':'/onlineCodeService/jxzysjfl_api/loadAllDictInfoToTreeDataByParam'
    };

    return {
      result,
      columns,
      isLoading: ref(true),
      apiUrls
    }
  },
  data() {
    return {
      showPickers:{},
      showTop:false,
      isH5:false,
      searchParam: { IsPage: true, CurrentPageNo: 1, PageSize: 20 },
      searchArea: "全部",
      searchAreaType: [
        { value: "全部", label: "全部", parent_id:"全部" }
      ],
      searchValue: "", // 检索内容
      searchType: "全部", // 检索类型
      searchTypeObject: [
        { value: "全部", label: "全部" }
      ],
      resultData: {},
      DataList: [],
      loading: false,
      QueryObject:{
        searchDict:{}
      },
      classActiveNameDict:{},
      classActive: '全部',
      classActiveDict:{},
      classItems: [{
        label: '全部', 
        value: '全部'
      },{
        label: '计算机', 
        value: '计算机'
      }],
      allClassItems:[]
    };
  },
  created() {
    
  },
  mounted() {
    this.$nextTick(() => {
      this.initClassItemsByXMLY()
      this.initClassItemsByWJLX()
      this.initClassItems()
    })
  },
  methods: {
    gotoRoute(obj){
      let routeUrl = this.$router.resolve({
        path: obj
      });
      window.location.href = routeUrl.href
    },
    onConfirm(item){
      let _obj = item.selectedOptions[0]
      this.classActiveNameDict[_obj.type] = _obj.text
      this.classActiveDict[_obj.type] = _obj.value
      this.classActive = '全部'
      this.showPickers[_obj.type] = false;
      this.searchData();
    },
    /** 与课程文档里 Mongo 字段名一致：优先 dict_code（接口树节点常有 dict_code，value 可能缺失） */
    dictFieldKey(item) {
      if (!item) return ''
      const raw =
        item.dict_code !== undefined && item.dict_code !== null && String(item.dict_code).length
          ? item.dict_code
          : item.value !== undefined && item.value !== null && String(item.value).length
            ? item.value
            : item.id
      return raw !== undefined && raw !== null ? String(raw) : ''
    },
    childSelectValue(c) {
      if (!c) return ''
      const raw =
        c.dict_code !== undefined && c.dict_code !== null && String(c.dict_code).length
          ? c.dict_code
          : c.value !== undefined && c.value !== null && String(c.value).length
            ? c.value
            : c.id
      return raw !== undefined && raw !== null ? String(raw) : ''
    },
    toColumns(type, items){
      var _columns = [{ text: '全部', value: '全部', type: type }]
      if (!items || !items.length) {
        return _columns
      }
      items.forEach((obj) => {
        const v = this.childSelectValue(obj)
        if (!v) return
        _columns.push({ text: obj.label || obj.dict_name, value: v, type: type })
      })
      return _columns
    },
    initClassItems(){
      this.isLoading = true
      let param = {
        "name": '我的课程/课程信息'
      }
      this.$http.post(this.apiUrls.getClassItems, param).then(res => {
        this.isLoading = false
        if(res){
          if (res.resultCode === 0 || res.resultCode === '0'){
            this.allClassItems = Array.isArray(res.resultData) ? res.resultData : [];
          }else{
            console.log(res.resultMsg)
          }
        }
      }).catch(error => {
        this.isLoading = false;
        showNotify('请求失败，请稍后再试！')
        console.log(error)
        console.log('失败')
      })
    },
    /** 当前是否按「一级 / 该维度字段存在」查询（与后端 classActive + $exists 一致） */
    isFirstLevelQueryActive(item) {
      const k = this.dictFieldKey(item)
      if (!k) return false
      return this.classActive === k && this.classActiveDict[k] === '全部'
    },
    /**
     * 点击一级名称：按该维度 Mongo 字段做「存在」筛选（classActive = 字段 dict_code）。
     * 再点同一一级可取消。选子类下拉时会清掉 classActive，避免与精确条件冲突。
     */
    toggleFirstLevelQuery(item) {
      const k = this.dictFieldKey(item)
      if (!k) return
      if (this.classActive === k) {
        this.classActive = '全部'
      } else {
        this.classActive = k
        this.classActiveDict[k] = '全部'
      }
      this.searchData()
    },
    /**
     * 首页「更多」：?l1=一级字段 dict_code；可选 ?l2=子类 dict_code（与下拉选子类一致，classActive 须为「全部」）。
     */
    applyRouteCatalogQuery() {
      const q = (this.$route && this.$route.query) || {}
      const code = this.queryParamFirst(q.l1)
      if (!code) return
      const roots = this.allClassItems || []
      if (!roots.length) return
      const rootObj = roots.find((o) => this.dictFieldKey(o) === code)
      if (!rootObj) return

      const l2Str = this.queryParamFirst(q.l2)
      if (l2Str !== '' && l2Str !== '全部') {
        const childCode = l2Str
        const ok = (rootObj.children || []).some((c) => this.childSelectValue(c) === childCode)
        if (!ok) return
        this.classActive = '全部'
        this.classActiveDict[code] = childCode
      } else {
        this.classActive = code
        this.classActiveDict[code] = '全部'
      }
      this.searchData()
    },
    /** 下拉变更：只走 classActiveDict，classActive 固定为「全部」以免后端 $exists 覆盖同字段精确条件 */
    onClassDictChange() {
      this.classActive = '全部'
      ;(this.allClassItems || []).forEach((obj) => {
        const k = this.dictFieldKey(obj)
        if (!k) return
        const v = this.classActiveDict[k]
        if (v === null || v === undefined || v === '') {
          this.classActiveDict[k] = '全部'
        }
      })
      this.searchData()
    },
    resetClassFilters() {
      this.classActive = '全部'
      ;(this.allClassItems || []).forEach((obj) => {
        const k = this.dictFieldKey(obj)
        if (k) this.classActiveDict[k] = '全部'
      })
      this.searchData()
    },
    searchData(){
      this.QueryObject.classActive = this.classActive
      this.QueryObject.classActiveDict = { ...this.classActiveDict }
      this.$emit('searchContentList', {
        ...this.QueryObject,
        searchDict: { ...(this.QueryObject.searchDict || {}) },
        classActiveDict: { ...this.classActiveDict },
        classActive: this.classActive
      })
    },
    initClassItemsByXMLY(){
      this.isLoading = true
      let param = {
        "name": '我的课程/项目来源'
      }
      this.$http.post(this.apiUrls.getClassItems, param).then(res => {
        this.isLoading = false
        if(res){
          if (res.resultCode == 0){
            this.searchAreaType = []
            res.resultData.forEach(obj => {
              if (this.searchAreaType.length == 0){
                this.searchAreaType.push({ value: '全部', label: '全部', parent_id:obj.parent_id })
              }
              this.searchAreaType.push({ value: obj.dict_code, label: obj.dict_name,parent_id:obj.parent_id })
            });
          }else{
            console.log(res.resultMsg)
          }
        }
      }).catch(error => {
        this.isLoading = false;
        showNotify('请求失败，请稍后再试！')
        console.log(error)
        console.log('失败')
      })
    },
    initClassItemsByWJLX(){
      this.isLoading = true
      let param = {
        "name": '我的课程/文件类型'
      }
      this.$http.post(this.apiUrls.getClassItems, param).then(res => {
        this.isLoading = false
        if(res){
          if (res.resultCode == 0){
            this.searchTypeObject = []
            res.resultData.forEach(obj => {
              if (this.searchTypeObject.length == 0){
                this.searchTypeObject.push({ value: '全部', label: '全部', parent_id:obj.parent_id })
              }
              this.searchTypeObject.push({ value: obj.dict_code, label: obj.dict_name,parent_id:obj.parent_id })
            });
            this.QueryObject.searchDict[this.searchTypeObject[0].parent_id] = this.searchTypeObject[0].value
          }else{
            console.log(res.resultMsg)
          }
        }
      }).catch(error => {
        this.isLoading = false;
        showNotify('请求失败，请稍后再试！')
        console.log(error)
        console.log('失败')
      })
    },
    goToSearchResult(closeTop) {
      this.QueryObject.searchDict.searchValue = this.searchValue;
      this.searchData();

      if(closeTop){
        this.showTop = false
      }
    },
    handleActive(item) {
      this.QueryObject.searchDict[item.parent_id] = item.value; 
      this.searchArea = item.value;
      this.goToSearchResult()
    },
    onClickTab(){
      this.searchData()
    },
    clearSearchParam(){
      this.classActiveNameDict = {}
      this.classActiveDict = {}
      this.resetClassFilters()
    },
    onChange(idx){
      this.checkedDict[idx] = !this.checkedDict[idx]
    },
    /** Vue Router 的 query 值可能是 string 或 string[] */
    queryParamFirst(val) {
      if (val == null || val === '') return ''
      const v = Array.isArray(val) ? val[0] : val
      return v == null || v === '' ? '' : String(v)
    }
  },
  computed: {
    routeCatalogKey() {
      const q = (this.$route && this.$route.query) || {}
      return [this.queryParamFirst(q.l1), this.queryParamFirst(q.l2)].join('|')
    }
  },
  watch: {
    allClassItems: {
      handler(newValue) {
        if (!Array.isArray(newValue)) return
        newValue.forEach((obj) => {
          const k = this.dictFieldKey(obj)
          if (k && this.classActiveDict[k] === undefined) {
            this.classActiveDict[k] = '全部'
          }
        })
        this.$nextTick(() => {
          this.applyRouteCatalogQuery()
        })
      },
      immediate: true
    },
    routeCatalogKey() {
      this.$nextTick(() => {
        this.applyRouteCatalogQuery()
      })
    }
  }

};
</script>

<style scoped>
.search-bar {
  width: 100%;
  height: 266px;
  background: url("../assets/imgs/searchBackground.png");
}

.search-bar-div {
  width: 60%;
  padding-left: 20%;
  padding-right: 20%;
  padding-top: 60px;
  margin: 0 auto;
}

.page-container {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0 auto;
  overflow: hidden;
}

.col-content {
  min-height: 36px;
}


.content {
  margin-top: 15px;
  margin-bottom: 5px;
  cursor: pointer;
  min-width: 300px;
}

.input-with-select {
  width: calc(100% - 120px)

}

.el-select {
  width: 130px;
}

.search-header {
  width: 100%;
  height: 150px;
  border: none;
  border-radius: 0px;
}

.tab {
  font-family: "Arial Negreta", "Arial";
  font-weight: 700;
  font-style: normal;
  margin-left: 50px;
  padding-top: 20px;
}

.tab span {
  margin-right: 15px;
  cursor: pointer;
  color: #c5c5c5;
}

.active {
  color: #fff !important;
  cursor: pointer;
}

.foot_tab {
  font-family: "Arial Negreta", "Arial";
  font-weight: 700;
  font-style: normal;
  margin-right: 15px;
}

.foot_tab span {
  margin-right: 15px;
  cursor: pointer;
}

input {
  width: 80%;
  height: 30px;
}

.button {
  width: 20%;
  color: #ffffff;
  background-color: unset;
  height: 30px;
  font-family: "Arial Normal", "Arial";
  font-weight: 900;
  font-style: normal;
  font-size: 20px;
  text-align: center;
  line-height: normal;
}

/* 菜单键 */
.fixedly-btn-left{
   /* 固定位置*/
   position: fixed;
   left: 0;
   display: flex;
   justify-content: center;
   align-items: center;
   width: 66px;
   height: 45px;
   background-color: #FFFFFF;
   /* 透明度*/
   opacity: 0.9;
   /* 图标大小*/
   font-size: 23px;
 }
.fixedly-btn-right{
   /* 固定位置*/
   position: fixed;
   right: 0;
   display: flex;
   justify-content: center;
   align-items: center;
   width: 66px;
   height: 45px;
   background-color: #FFFFFF;
   /* 透明度*/
   opacity: 0.9;
   /* 图标大小*/
   font-size: 23px;
 }
 /* 占位符 (将导航栏最后一项显现出来)*/
 .placeholder{
   flex-shrink: 0;
   width: 66px;
   height: 45px;
 }
</style>

<style scoped>


/* 与 courseMajorDisplay 同宽：外层使用 global.css 的 .ibp-major-content-shell（大屏 80% 居中） */
.search-wrap {
  --major-nav-blue: #175cc4;
  padding-top: 4px;
  padding-bottom: 16px;
}

.home-course-search-card.toolbar-card {
  width: 100%;
  max-width: none;
  margin: 0;
}

.toolbar-card {
  background: linear-gradient(180deg, #ffffff 0%, #fafcff 100%);
  border-radius: 16px;
  padding: 20px 22px 22px;
  box-shadow: 0 8px 36px rgba(23, 92, 196, 0.1);
  margin-bottom: 12px;
  border: 1px solid rgba(23, 92, 196, 0.1);
}

.toolbar-card__intro {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.toolbar-card__label {
  font-size: 17px;
  font-weight: 700;
  color: #303133;
}

.search-input {
  max-width: 100%;
}

.search-ico {
  color: #909399;
}

.search-filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: stretch;
  margin-bottom: 14px;
}

.dim-card {
  display: inline-flex;
  align-items: stretch;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(23, 92, 196, 0.08);
  box-shadow: 0 4px 24px rgba(23, 92, 196, 0.08);
}

.dim-l1-chip {
  border: none;
  margin: 0;
  padding: 0 14px;
  min-height: 40px;
  max-width: 140px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  background: transparent;
  cursor: pointer;
  text-align: left;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease;
}

.dim-l1-chip:hover {
  background: #f0f6ff;
}

.dim-l1-chip--on {
  background: #e8f1fc !important;
  color: #175cc4 !important;
  font-weight: 600;
}

.dim-l1-chip--on:hover {
  background: #dceaf9 !important;
}

.dim-select-wrap {
  display: flex;
  align-items: center;
  border-left: 1px solid rgba(23, 92, 196, 0.12);
  padding: 0 8px 0 6px;
  min-width: 128px;
  background: #fafcff;
}

.dim-select-el {
  width: 148px;
  max-width: 46vw;
}

.dim-select-el :deep(.el-input__wrapper) {
  box-shadow: none !important;
  background: transparent !important;
  padding-left: 4px;
  padding-right: 8px;
}

.dim-select-el :deep(.el-input__inner::placeholder) {
  color: #909399;
}

.h5-l1-panel {
  padding: 16px 16px 12px;
  background: linear-gradient(180deg, #fafcff 0%, #fff 100%);
  border-bottom: 1px solid rgba(23, 92, 196, 0.08);
}

.h5-l1-panel-title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #909399;
  margin-bottom: 10px;
  padding: 0 2px;
}

.h5-l1-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.h5-l1-pill {
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: rgba(255, 255, 255, 0.95);
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 14px;
  border-radius: 999px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.h5-l1-pill:active {
  transform: scale(0.98);
}

.h5-l1-pill--on {
  border-color: #175cc4;
  color: #fff;
  background: #175cc4;
  box-shadow: 0 4px 14px rgba(23, 92, 196, 0.28);
}

.h5-filter-form {
  margin-top: 8px;
}

.h5-sheet-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 16px 16px 22px;
  background: #fff;
}

.h5-footer-btn {
  min-width: 132px;
}

.h5-footer-btn--primary {
  box-shadow: 0 4px 16px rgba(25, 137, 250, 0.28);
}

.search-row {
  margin: 0 30px 20px;
  border-bottom: 1px solid #e0e0e0; /* 1像素宽的实线，颜色为黑色，可以根据需要更改颜色 */
  margin-bottom: 10px; /* 可选：增加下方间距 */
}


.search-list {
  max-width: 1148px;
}


.search-row .search-col-label {
  text-align: center;
}

.search-row .search-col-content {
}

.search-row .search-col-content .loop-wrapper .activeClass {
  color: #3464e1;
}

.search-row .search-col-content .loop-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.search-row .search-col-content .loop-wrapper .loop-item {
  margin: 0 20px 10px 0;
  width: 150px;
}

.search-row .search-col-content .loop-wrapper .loop-item:hover {
  cursor: pointer;
  color: #3464e1;
}

.search-row .search-col-content .loop-wrapper .loop-item.sort-item {
  display: flex;
  flex-wrap: nowrap;
}

.search-row
  .search-col-content
  .loop-wrapper
  .loop-item.sort-item
  .sort-arrow-wrapper {
  display: flex;
  flex-direction: column;
  margin: -4px 0 0 4px;
}

.search-row
  .search-col-content
  .loop-wrapper
  .loop-item.sort-item
  .sort-arrow-wrapper
  .el-icon-caret-top.active,
.el-icon-caret-bottom.active {
}

.search-row
  .search-col-content
  .loop-wrapper
  .loop-item.sort-item
  .sort-arrow-wrapper
  .el-icon-caret-top.active,
.el-icon-caret-bottom.active {
  color: #3464e1;
}

.search-row .search-col-content .loop-wrapper .active {
  color: #3464e1;
}

</style>
<style>
.el-tabs__nav-wrap::after {
    background-color: transparent !important;
  }
.el-tabs .el-tabs__active-bar {
    background-color: transparent !important;
}

.van-nav-bar--fixed .van-tabs__line {
  width: unset
}
</style>